module.exports = __webpack_public_path__ + "img/resource-tech-image-32.d4d40782.jpg";